/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
/**
 * 
 * @export
 * @interface HistoryPropertyChange
 */
export interface HistoryPropertyChange {
    /**
     * 
     * @type {string}
     * @memberof HistoryPropertyChange
     */
    name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof HistoryPropertyChange
     */
    originalValue?: string | null;
    /**
     * 
     * @type {string}
     * @memberof HistoryPropertyChange
     */
    newValue?: string | null;
    /**
     * 
     * @type {string}
     * @memberof HistoryPropertyChange
     */
    uniqueName?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof HistoryPropertyChange
     */
    isLocalizable?: boolean;
    /**
     * 
     * @type {string}
     * @memberof HistoryPropertyChange
     */
    $type?: HistoryPropertyChangeTypeEnum;
}


/**
 * @export
 */
export const HistoryPropertyChangeTypeEnum = {
    PtwPtw100AppZeroCoreSharedEntityHistoryHistoryPropertyChangePtwPtw100AppZeroCoreShared: 'Ptw.Ptw100.AppZero.Core.Shared.EntityHistory.HistoryPropertyChange, Ptw.Ptw100.AppZero.Core.Shared'
} as const;
export type HistoryPropertyChangeTypeEnum = typeof HistoryPropertyChangeTypeEnum[keyof typeof HistoryPropertyChangeTypeEnum];



/**
 * Check if a given object implements the HistoryPropertyChange interface.
 */
export function instanceOfHistoryPropertyChange(value?: unknown): value is HistoryPropertyChange {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(HistoryPropertyChangeTypeEnum)[0];
}

export function HistoryPropertyChangeFromJSON(json: any): HistoryPropertyChange {
    return HistoryPropertyChangeFromJSONTyped(json, false);
}

export function HistoryPropertyChangeFromJSONTyped(json: any, ignoreDiscriminator: boolean): HistoryPropertyChange {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'] == null ? undefined : json['name'],
        'originalValue': json['originalValue'] == null ? undefined : json['originalValue'],
        'newValue': json['newValue'] == null ? undefined : json['newValue'],
        'uniqueName': json['uniqueName'] == null ? undefined : json['uniqueName'],
        'isLocalizable': json['isLocalizable'] == null ? undefined : json['isLocalizable'],
        '$type': json['$type'] == null ? undefined : json['$type'],
    };
}

export function HistoryPropertyChangeToJSON(value?: HistoryPropertyChange | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'name': value['name'],
        'originalValue': value['originalValue'],
        'newValue': value['newValue'],
        'uniqueName': value['uniqueName'],
        'isLocalizable': value['isLocalizable'],
        '$type': value['$type'],
    });
}

